module.exports = __webpack_public_path__ + "images/emoji/mailbox_with_no_mail.1198292d8215018f438f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mailbox_with_no_mail.png
// module id = 8KbI
// module chunks = 24